import React from 'react'
import PropTypes from 'prop-types'
import Logo from '../assets/MainLogo/Navy/ThirdLine Main Logo Navy.svg'

// Standalone landing for an authenticated user with none of the three app
// flags — rendered outside every app so no app data hooks mount.
const NoAppAccess = ({ onLogout }) => (
  <div
    style={{ backgroundColor: '#f5f5f5' }}
    className="vh-100 d-flex flex-column align-items-center justify-content-center gap-4 px-4 text-center"
  >
    <img
      src={Logo}
      alt="ThirdLine"
      style={{ maxHeight: '40px' }}
    />
    <div style={{ maxWidth: '32rem' }}>
      <h1 className="h4 mb-3">No application access</h1>
      <p className="mb-0 text-muted">
        Your ThirdLine account does not have access to any applications yet.
        Please contact your administrator to request access, or reach us at{' '}
        <a href="mailto:support@thirdline.io" className="text-decoration-underline">
          support@thirdline.io
        </a>
        .
      </p>
    </div>
    <button type="button" className="btn btn-primary" onClick={onLogout}>
      Log out
    </button>
  </div>
)

NoAppAccess.propTypes = {
  onLogout: PropTypes.func.isRequired
}

export default NoAppAccess
